import { RefreshCw } from "lucide-react";

export const TradingControlStrip = ({
  tickers = [],
  selectedTicker,
  onSelectTicker,
  marketRegime,
  dailyStatus,
  loading,
  onRefresh,
}) => {
  return (
    <div
      data-testid="trading-control-strip"
      className="panel p-3 flex items-center gap-3 sm:gap-5 flex-wrap lg:col-span-7"
    >
      <Group label="REGIME">
        <span
          className="label-micro px-2 py-1 border border-magenta text-magenta"
          style={{ borderRadius: 2 }}
          data-testid="market-regime-badge"
        >
          {marketRegime || "—"}
        </span>
      </Group>
      <Divider />
      <Group label="STATUS">
        <span
          className="label-micro px-2 py-1 border border-border text-foreground"
          style={{ borderRadius: 2 }}
          data-testid="daily-status-badge"
        >
          {dailyStatus || "—"}
        </span>
      </Group>
      <Divider />
      <Group label="EMITEN">
        <select
          data-testid="ticker-filter"
          value={selectedTicker || ""}
          onChange={(e) => onSelectTicker(e.target.value || null)}
          className="px-2 py-1 text-[11px] uppercase tracking-[0.12em] font-mono border border-border bg-surface text-foreground"
          style={{ borderRadius: 2 }}
        >
          <option value="">ALL</option>
          {tickers.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </Group>

      <div className="ml-auto flex items-center gap-2">
        <button
          type="button"
          data-testid="refresh-data-btn"
          onClick={onRefresh}
          disabled={loading}
          className="btn-magenta"
        >
          <RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} />
          {loading ? "Syncing…" : "Refresh"}
        </button>
      </div>
    </div>
  );
};

const Group = ({ label, children }) => (
  <div className="flex items-center gap-2">
    <span className="label-micro">{label}</span>
    {children}
  </div>
);

const Divider = () => <span className="h-5 w-px bg-border hidden sm:inline-block" />;

export default TradingControlStrip;
